import { render, staticRenderFns } from "./wtsTask.vue?vue&type=template&id=6a2952d5&scoped=true"
import script from "./wtsTask.vue?vue&type=script&lang=js"
export * from "./wtsTask.vue?vue&type=script&lang=js"
import style0 from "./wtsTask.vue?vue&type=style&index=0&id=6a2952d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2952d5",
  null
  
)

export default component.exports